import { render, staticRenderFns } from "./TopStudents.vue?vue&type=template&id=2d1b9fd6&scoped=true&"
import script from "./TopStudents.vue?vue&type=script&lang=js&"
export * from "./TopStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b9fd6",
  null
  
)

export default component.exports